module.exports = __webpack_public_path__ + "img/usergroup.86bc5c15.svg";